import React from "react";
import styles from "./ButtonsGroup.module.scss";

const ButtonsGroup = ({ onSave, onCancel, saveText, cancelText }) => {
  return (
    <div className={styles.buttonContainer}>
      <button className={styles.cancelButton} onClick={onCancel}>
        {cancelText}
      </button>
      
      <button className={styles.saveButton} onClick={onSave}>
        {saveText}
      </button>
      
    </div>
  );
};

export default ButtonsGroup;
